/*       */
import React from 'react';
import { queryData } from 'app/utils/redux/action-utils';
import entityDetailsQuery from 'graphql/maps/entityDetailsQuery';

import LayerSidebar from 'app/containers/Sidebars/LayerSidebar';

import { buildSidebar as buildSidebarAction, closeSidebar as closeSidebarAction } from 'store/actions/sidebar/sidebarActions';

export const openLayerSidebar = props => (dispatch, getState) => {
    return buildSidebarAction({
        title: props.title,
        content: <LayerSidebar {...props} />,
        isOpen: true,
    })(dispatch, getState);
};

export const loadEntityData = async (type, id) => {
    try {
        const data = await queryData(entityDetailsQuery, { type, id });
        return data?.data?.entity || null;
    } catch (error) {
        console.error('Error fetching entity data:', error);
        return null;
    }
};

export const closeLayerSidebar = closeSidebarAction;
